import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["children", "expanded", "focussed", "id", "index", "title", "onClick", "onKeyDown", "onFocus"];
import React, { forwardRef, useRef, useEffect } from 'react';
import cx from 'classnames';
import { useMergeRefs } from 'use-callback-ref';
import { ChevronForward } from '@mediahuis/chameleon-theme-wl/icons';
import Icon from '../../Icon';
import Box from '../../Box';
import system from '../../../system';
import styles from './index.module.scss';
var SYSTEM_PROPS = []; // If system props added - stories should be written!

var AccordionItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      expanded = _ref.expanded,
      focussed = _ref.focussed,
      id = _ref.id,
      index = _ref.index,
      title = _ref.title,
      _onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      _onFocus = _ref.onFocus,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var innerRef = useRef(null);
  var combinedRef = useMergeRefs([ref, innerRef]);

  var _system = system(props, SYSTEM_PROPS),
      className = _system[0],
      style = _system[1],
      rest = _system[2];

  useEffect(function () {
    if (focussed) {
      innerRef.current.focus();
    }
  }, [focussed]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: cx(styles.root, className),
    style: style
  }, /*#__PURE__*/React.createElement(Box, _extends({
    as: "button",
    "aria-expanded": expanded ? 'true' : 'false',
    "aria-controls": id + "-section",
    id: id + "-accordion",
    onClick: function onClick() {
      return _onClick && _onClick(index);
    },
    onKeyDown: onKeyDown,
    width: "full",
    textAlign: "left",
    position: "relative",
    ref: combinedRef,
    className: cx(styles.button, expanded && styles.buttonExpanded),
    onFocus: function onFocus() {
      return _onFocus && _onFocus(index);
    }
  }, rest), /*#__PURE__*/React.createElement(Icon, {
    position: "absolute",
    left: 5,
    "aria-hidden": "true",
    size: "small",
    as: ChevronForward,
    className: cx(styles.icon, expanded && styles.iconExpanded)
  }), title), /*#__PURE__*/React.createElement("div", {
    id: id + "-section",
    role: "region",
    "aria-labelledby": id + "-accordion",
    className: styles.panel,
    hidden: !expanded,
    pl: 10
  }, children));
});
AccordionItem.displayName = 'AccordionItem';
AccordionItem.identifier = AccordionItem.displayName; // used in docs website

AccordionItem.clonableProps = SYSTEM_PROPS;
export default AccordionItem;